var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPerson = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.978,
    height: 23.833,
    viewBox: "0 0 21.978 23.833",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "person-svgrepo-com",
    transform: "translate(-1.5 -1.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9",
    "data-name": "Elipse 9",
    cx: 6.029,
    cy: 6.029,
    r: 6.029,
    transform: "translate(6.46 2.75)",
    fill: "rgba(0,0,0,0)",
    stroke: "#ffce05",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_214",
    "data-name": "Trazado 214",
    d: "M2.75,18.525A9.407,9.407,0,0,1,12.489,9.25a9.407,9.407,0,0,1,9.739,9.275",
    transform: "translate(0 5.558)",
    fill: "rgba(0,0,0,0)",
    stroke: "#ffce05",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPerson);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/person.e582550dfa8977c60d5931788a939f55.svg";